import type { Project } from '@shared/models/project.model';
import { getVersionById, removeBuildingVersion } from '../../project.helpers';
import { ProjectChangeType } from '../update-engine.models';
import type { ProjectChangeMap } from '../update-engine.models';

export type VersionRemoveChange =
  ProjectChangeMap[ProjectChangeType.VersionRemove];

/**
 * Apply a single {@link ProjectChangeType.VersionRemove} change by delegating to
 * {@link removeBuildingVersion}, which also hands {@link Project.active_version_id} over to
 * the preceding version when the removed one was active.
 *
 * Returns the input project unchanged when the version is already gone, so replaying a batch
 * never throws on an outdated change.
 */
export const applyVersionRemoveChange = (
  project: Project,
  change: VersionRemoveChange,
): Project => {
  if (!getVersionById(project, change.versionId, false)) return project;
  return removeBuildingVersion(project, change.versionId);
};
